  let preorderableVariants = { 
    /*"10-2100-G": {
      "price": "679000"
      ,"available": "July"
      ,"terms": "/pages/bolt-pre-order-agreement"
    }
    ,"10-2100-V": {
      "price": "679000"
      ,"available": "July"
      ,"terms": "/pages/bolt-pre-order-agreement"
    }
    ,"10-2101-G": {
      "price": "364000"
      ,"available": "July"
      ,"terms": "/pages/bolt-pre-order-agreement"
    }
    ,"10-2101-V": {
      "price": "364000"
      ,"available": "July"
      ,"terms": "/pages/bolt-pre-order-agreement"
    }
    ,"10-2102-G": {
      "price": "364000"
      ,"available": "July"
      ,"terms": "/pages/bolt-pre-order-agreement"
    }
    ,"10-2102-V": {
      "price": "364000"
      ,"available": "July"
      ,"terms": "/pages/bolt-pre-order-agreement"
    }
    ,"10-2110-G": {
      "price": "1199000"
      ,"available": "July"
      ,"terms": "/pages/bolt-pre-order-agreement"
    }
    ,"10-2110-V": {
      "price": "1199000"
      ,"available": "July"
      ,"terms": "/pages/bolt-pre-order-agreement"
    }
    ,"10-2111-G": {
      "price": "649000"
      ,"available": "July"
      ,"terms": "/pages/bolt-pre-order-agreement"
    }
    ,"10-2111-V": {
      "price": "649000"
      ,"available": "July"
      ,"terms": "/pages/bolt-pre-order-agreement"
    }
    ,"10-2112-G": {
      "price": "649000"
      ,"available": "July"
      ,"terms": "/pages/bolt-pre-order-agreement"
    }
    ,"10-2112-V": {
      "price": "649000"
      ,"available": "July"
      ,"terms": "/pages/bolt-pre-order-agreement"
    }
    ,"10-BOLT-750-4K": {
      "price": "399000"
      ,"available": "July"
      ,"terms": "/pages/bolt-pre-order-agreement"
    }
    ,"10-BOLT-1500-4K": {
      "price": "799000"
      ,"available": "July"
      ,"terms": "/pages/bolt-pre-order-agreement"
    }*/
  };
